// Sticky top bar. The only place backdrop-blur is used (README "Sticky top bar").
import { MONO } from './primitives';

export function TopBar({
  signedIn,
  householdLabel,
  onSignOut,
}: {
  signedIn: boolean;
  householdLabel: string;
  onSignOut: () => void;
}) {
  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        background: 'rgba(5,50,60,0.82)',
        backdropFilter: 'blur(12px) saturate(120%)',
        WebkitBackdropFilter: 'blur(12px) saturate(120%)',
        borderBottom: '1px solid rgba(127,227,232,0.22)',
      }}
    >
      <div
        style={{
          maxWidth: 640,
          margin: '0 auto',
          padding: '12px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, minWidth: 0 }}>
          <span style={{ fontSize: 19, fontWeight: 900, letterSpacing: '-0.03em' }}>water hazard</span>
          <span style={{ fontFamily: MONO, fontSize: 12, color: 'var(--cyan)' }}>'27</span>
        </div>
        {signedIn ? (
          <button type="button" className="wh-topbar-link" onClick={onSignOut}>
            {householdLabel} · sign out
          </button>
        ) : (
          <a
            href="#respond"
            style={{ fontFamily: MONO, fontSize: 13, color: 'var(--muted)' }}
          >
            sign in
          </a>
        )}
      </div>
    </div>
  );
}
